import React from 'react';

const AuthRoute = ({ component: Component, fallback: Fallback, token, props }) => (
    token ? <Component {...props} /> : <Fallback {...props} />
);

export default AuthRoute;